// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const updateBenefitClaimedMutation = gql`
  mutation updateBenefitClaimed($input: UpdateBenefitClaimedInput!) {
    updateBenefitClaimed(input: $input) {
      code
      message
      success
    }
  }
`;
